import type { Flag } from './flag-types';
import { checkOfCurrentStep, guardrailMarginBp } from './flag-guardrail';
import { formatWait } from './flag-status';

/**
 * What the Guardrail card shows: the last check when it is about the current step, the margin
 * it was judged with, how long ago it ran, and whether the visitor ID it counts with is off.
 * The flag refetches every FLAG_POLL_MS, so "checked 4m ago" moves with it.
 */
export const useFlagGuardrail = (flag: Flag) => {
  const rollout = flag.flagRollout;
  const check = checkOfCurrentStep(rollout);
  const now = Date.now();

  return {
    check,
    verdict: check?.verdict ?? null,
    marginBp: guardrailMarginBp(rollout),
    checkedAgo: check ? formatWait(Math.max(0, now - check.checkedAt)) : null,
    visitorIdOff: !flag.website?.visitorIdEnabled,
    // Nothing is checked before publishing: the card says so rather than promise a check soon.
    isDraft: flag.status === 'Draft',
  };
};

export type FlagGuardrailManager = ReturnType<typeof useFlagGuardrail>;
